// 新版生涯测评
const CareerEvalution = () => import('../views/ceping/careerEvaluation/index');
const Navigation = () => import('../views/ceping/careerEvaluation/public/navigation');
const careerEvaluationHome= () => import('../views/ceping/careerEvaluation/public/home');
const guide= () => import('../views/ceping/careerEvaluation/public/guide');
const success= () => import('../views/ceping/careerEvaluation/public/success');
//人格特性
const rgtx= () => import('../views/ceping/careerEvaluation/rgtx/index');
const rgtx11= () => import('../views/ceping/careerEvaluation/rgtx/ques11');
//智能水平
const znsp= () => import('../views/ceping/careerEvaluation/znsp/index');
const znsp11= () => import('../views/ceping/careerEvaluation/znsp/ques11');
const znsp12= () => import('../views/ceping/careerEvaluation/znsp/ques12');
const znsp21= () => import('../views/ceping/careerEvaluation/znsp/ques21');
const znsp22= () => import('../views/ceping/careerEvaluation/znsp/ques22');
const znsp31= () => import('../views/ceping/careerEvaluation/znsp/ques31');
const znsp32= () => import('../views/ceping/careerEvaluation/znsp/ques32');
const znsp33= () => import('../views/ceping/careerEvaluation/znsp/ques33');
const znsp41= () => import('../views/ceping/careerEvaluation/znsp/ques41');
const znsp42= () => import('../views/ceping/careerEvaluation/znsp/ques42');
const znsp43= () => import('../views/ceping/careerEvaluation/znsp/ques43');
const znsp51= () => import('../views/ceping/careerEvaluation/znsp/ques51');
const znsp52= () => import('../views/ceping/careerEvaluation/znsp/ques52');
const znsp53= () => import('../views/ceping/careerEvaluation/znsp/ques53');
const znsp61= () => import('../views/ceping/careerEvaluation/znsp/ques61');
const znsp71= () => import('../views/ceping/careerEvaluation/znsp/ques71');
const znsp81= () => import('../views/ceping/careerEvaluation/znsp/ques81');
const znsp91= () => import('../views/ceping/careerEvaluation/znsp/ques91');
const znsp101= () => import('../views/ceping/careerEvaluation/znsp/ques101');
const znspPlay= () => import('../views/ceping/careerEvaluation/znsp/play');
//兴趣倾向
const xqqx= () => import('../views/ceping/careerEvaluation/xqqx/index');
const xqqx11= () => import('../views/ceping/careerEvaluation/xqqx/ques11');
//职业价值观
const zyjzg= () => import('../views/ceping/careerEvaluation/zyjzg/index');
const zyjzg11= () => import('../views/ceping/careerEvaluation/zyjzg/ques11');
//心理适应性
const xlsyx= () => import('../views/ceping/careerEvaluation/xlsyx/index');
const xlsyx11= () => import('../views/ceping/careerEvaluation/xlsyx/ques11');

export default[
    {
        path: '/careerevalution',
        component: CareerEvalution ,
        meta: {requireAuth: true, roles: ['student']},
        children: [
            {
                path: '/careerevalution/navigation',
                name: '导航页',
                component: Navigation,
                meta: {requireAuth: true, roles: ['student']},
            },
            {
                path: '/careerevalution/home',
                name: '主页',
                component: careerEvaluationHome,
                meta: {requireAuth: true, roles: ['student']},
            },
            {
                path: '/careerevalution/guide',
                name: '指导页',
                component: guide,
                meta: {requireAuth: true, roles: ['student']},
            },
            //1.人格特性
            {
                path: '/careerevalution/rgtx',
                name: '人格特性',
                component: znsp,
                meta: {requireAuth: true, roles: ['student']},
                children:[
                    {
                        path: '/careerevalution/rgtx/ques11',
                        name: '人格特性答题',
                        component: rgtx11,
                        meta: {requireAuth: true, roles: ['student']},
                    }
                ]
            },
            //2.智能水平
            {
                path: '/careerevalution/znsp',
                name: '认知潜能',
                component: znsp,
                meta: {requireAuth: true, roles: ['student']},
                children:[
                    {
                        path: '/careerevalution/znsp/ques11',
                        name: '语言能力',
                        component: znsp11,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques12',
                        name: '语言表达',
                        component: znsp12,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques21',
                        name: '自然关系',
                        component: znsp21,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques22',
                        name: '自然类别',
                        component: znsp22,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques31',
                        name: '空间比例',
                        component: znsp31,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques32',
                        name: '空间艺术',
                        component: znsp32,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques33',
                        name: '空间色彩',
                        component: znsp33,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques41',
                        name: '情景排序',
                        component: znsp41,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques42',
                        name: '情景分析',
                        component: znsp42,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques43',
                        name: '情景应对',
                        component: znsp43,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques51',
                        name: '数学运算',
                        component: znsp51,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques52',
                        name: '数学推理',
                        component: znsp52,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques53',
                        name: '逻辑推理',
                        component: znsp53,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques61',
                        name: '空间表象',
                        component: znsp61,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques71',
                        name: '情绪识别',
                        component: znsp71,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques81',
                        name: '空间定向',
                        component: znsp81,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/play',
                        name: '视频演示',
                        component: znspPlay,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques91',
                        name: '迷宫',
                        component: znsp91,
                        meta: {requireAuth: true, roles: ['student']},
                    },
                    {
                        path: '/careerevalution/znsp/ques101',
                        name: '音乐能力',
                        component: znsp101,
                        meta: {requireAuth: true, roles: ['student']},
                    }
                ]
            },
            //3.兴趣倾向
            {
                path: '/careerevalution/xqqx',
                name: '兴趣倾向',
                component: xqqx,
                meta: {requireAuth: true, roles: ['student']},
                children:[
                    {
                        path: '/careerevalution/xqqx/ques11',
                        name: '兴趣倾向答题',
                        component: xqqx11,
                        meta: {requireAuth: true, roles: ['student']},
                    }
                ]
            },
            //4.职业价值观
            {
                path: '/careerevalution/zyjzg',
                name: '职业价值观',
                component: zyjzg,
                meta: {requireAuth: true, roles: ['student']},
                children:[
                    {
                        path: '/careerevalution/zyjzg/ques11',
                        name: '职业价值观答题',
                        component: zyjzg11,
                        meta: {requireAuth: true, roles: ['student']},
                    }
                ]
            },
            //5.心理适应性
            {
                path: '/careerevalution/xlsyx',
                name: '心理适应性',
                component: xlsyx,
                meta: {requireAuth: true, roles: ['student']},
                children:[
                    {
                        path: '/careerevalution/xlsyx/ques11',
                        name: '心理适应性答题',
                        component: xlsyx11,
                        meta: {requireAuth: true, roles: ['student']},
                    }
                ]
            },
            {
                path: '/careerevalution/success',
                name: '提交成功',
                component: success,
                meta: {requireAuth: true, roles: ['student']},
            },
        ]
    }
]